<template>
  <div
    ref="parallaxParent"
    class="parallax">
    <slot class="parallax__item" />
    <slot
      name="static"
      class="parallax__static" />
  </div>
</template>

<script>
import { hasMouse } from 'Root/helpers/tools';

export default {
  name: 'MouseShiftParallax',

  props: {
    isReverse: {
      type: Boolean,
      default: false,
    },

    maxParallaxShift: {
      type: Object,
      default: () => ({
        x: 5,
        y: 5,
      }),
    },

    baseTransforms: {
      type: Object,
      default: null,
    },
  },

  watch: {
    baseTransforms(newValue, oldValue) {
      if (oldValue && JSON.stringify(newValue) !== JSON.stringify(oldValue) && this.$slots.default) {
        // without next tick parallaxNode (this.$slots.default[0].elm) will be undefined
        this.$nextTick(() => {
          // for initial position (= baseTransforms values)
          this.parallax();
        });
      }
    },
  },

  mounted() {
    this.initParallax();
  },

  beforeDestroy() {
    this.destroyParallax();
  },

  methods: {
    parallax(event) {
      const parallaxNode = this.$slots.default[0].elm;
      const axisShift = {};

      if (event && hasMouse) {
        // parallax only if mouse is detected and we got an event
        const { parallaxParent } = this.$refs;
        const parallaxParentPosition = parallaxParent.getBoundingClientRect();
        const cursorCoeff = {
          x: (event.clientX - parallaxParentPosition.x) / parallaxParentPosition.width,
          y: (event.clientY - parallaxParentPosition.y) / parallaxParentPosition.height,
        };
        axisShift.x = cursorCoeff.x * this.maxParallaxShift.x - (this.maxParallaxShift.x / 2);
        axisShift.y = cursorCoeff.y * this.maxParallaxShift.y - (this.maxParallaxShift.y / 2);

        if (this.isReverse) {
          axisShift.x = -axisShift.x;
          axisShift.y = -axisShift.y;
        }
      } else {
        // default position
        axisShift.x = 0;
        axisShift.y = 0;
      }

      let transforms = [];

      if (this.baseTransforms !== null && this.baseTransforms.start) {
        transforms = [this.baseTransforms.start];
      }

      transforms.push(`translate(
        ${axisShift.x}%,
        ${axisShift.y}%
      )`);

      if (this.baseTransforms !== null && this.baseTransforms.end) {
        transforms.push(this.baseTransforms.end);
      }

      parallaxNode.style.transform = transforms.join(' ');
    },

    initParallax() {
      this.$nextTick(() => {
        if (this.$slots.default) {
          this.$refs.parallaxParent.addEventListener('mousemove', this.parallax);
          this.parallax();
        }
      });
    },

    destroyParallax() {
      if (this.$slots.default) {
        this.$refs.parallaxParent.removeEventListener('mousemove', this.parallax);
        this.$slots.default[0].elm.style.transform = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
